import React, { Component } from "react";
import Dropdown from "../content/Dropdown";
import axios from "axios";
import Modal from "react-modal";

class ManagerLocationPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mngwwid: "",
      mnglocation: "",
      isDisplaymngactualLocation: false,
      mngName: "",
      locationreferenceID: "",
      locationname: "",
      regionname: "",
      countryname: "",
      statename: "",
      dropdownData: [],
      locationselected: {},
      countryselected: {},
      stateselected: {},
      splocationselected: {},
      currency: "DEFAULT_CURRENCY",
      isMandatory: false,
      isValidMngName: false,
      isSubmitted: false,
      isValidated: false,
      isLoaded: false,
      isDifferentlocation: false,
    };
  }
  handleChange = (e) => {
    if (e.target.value !== undefined) {
      this.setState({
        mngwwid: e.target.value.replace(/ /g, ""),
        mngName: "",
        mnglocation: "",
        isDisplaymngactualLocation: false,
        isSubmitted: false,
        isValidated: false,
      });
    }
  };
  showMnglocation = async () => {
    try {
      let res = await axios({
        method: "POST",
        url: process.env.REACT_APP_WORKDAY_API_URL + "getManagerDetails",
        headers: {
          apiKey: process.env.REACT_APP_WORKDAY_API_KEY,
          clientKey: process.env.REACT_APP_WORKDAY_API_CLIENTKEY,
          "Content-Type": "application/json",
        },
        data: {
          managerWWID: this.state.mngwwid,
        },
      });
      if (res.status === 200) {
        this.setState({
          mnglocation: res.data.managerLocation,
          isDisplaymngactualLocation: true,
        });
      } else {
        this.setState({
          mnglocation: "",
          isDisplaymngactualLocation: false,
        });
      }
    } catch (error) {
      this.setState({
        mnglocation: "",
        isDisplaymngactualLocation: false,
      });
    }
    if (this.state.mnglocation !== "") {
      this.setState({
        isDisplaymngactualLocation: true,
      });
    }
  };
  componentDidMount() {
    axios({
      method: "GET",
      url: process.env.REACT_APP_WORKDAY_API_URL + "getAllLocations",
      headers: {
        apiKey: process.env.REACT_APP_WORKDAY_API_KEY,
        clientKey: process.env.REACT_APP_WORKDAY_API_CLIENTKEY,
        "Content-Type": "application/x-www-form-urlencoded",
      },
      // console.log(headers);
    })
      .then((res) => {
        this.setState({
          dropdownData: res.data.allLocations,
          isLoaded: true,
        });
        if (this.props.regionname !== "") {
          this.setState({
            locationselected: {
              name: this.props.regionname,
              value: this.props.regionname,
            },
            regionname: this.props.regionname,
          });
        }
        if (this.props.countryname !== "") {
          this.setState({
            countryselected: {
              name: this.props.countryname,
              value: this.props.countryname,
            },
            countryname: this.props.countryname,
          });
        }
        /* if (this.props.statename !== '') {
                this.setState({
                    stateselected: {
                        name: this.props.statename,
                        value: this.props.statename
                    },
                    statename: this.props.statename,
                });
            } */
        if (this.props.locationId !== "") {
          const selLoc = this.state.dropdownData.filter(
            (item) => item.locationId === this.props.locationId
          );
          if (selLoc.length !== 0) {
            this.setState({
              splocationselected: {
                name: selLoc[0].location,
                value: selLoc[0].location,
              },
              locationreferenceID: this.props.locationId,
              locationname: selLoc[0].location,
            });
          }
        }
        if (this.state.mngwwid != "") {
          this.showMnglocation();
        }
      })
      .catch((error) => {
        //on error
        console.log(error);
        alert("There is an error in API call.\n" + error);
      });

    this.setState({ mngwwid: this.props.mngwwid, mngName: this.props.mngName });
  }
  regiondata = (locationselected) => {
    this.setState({
      locationselected,
      currency: locationselected.value,
      regionname: locationselected.value,
    });
    this.setState({
      countryselected: {},
      countryname: "",
      stateselected: {},
      statename: "",
      splocationselected: {},
      locationreferenceID: "",
      locationname: "",
    });
  };
  countrydata = (countryselected) => {
    this.setState({
      countryselected,
      currency: countryselected.value,
      countryname: countryselected.value,
    });
    this.setState({
      stateselected: {},
      statename: "",
      splocationselected: {},
      locationreferenceID: "",
      locationname: "",
    });
  };
  /* statedata = (stateselected) => {
        this.setState({ stateselected, currency: stateselected.value, statename: stateselected.value });
        this.setState({ splocationselected: {}, locationreferenceID: '', locationname: '' });

    } */
  splocationdata = (splocationselected) => {
    this.setState({
      splocationselected,
      currency: splocationselected.value,
      isSubmitted: false,
    });

    this.setState({ locationname: splocationselected.value });

    let refid = this.state.dropdownData.filter((item) => {
      if (item.location == splocationselected.value) return item;
    });

    this.setState({ locationreferenceID: refid[0].locationId });
  };
  validate = async () => {
    try {
      let res = await axios({
        method: "POST",
        url: process.env.REACT_APP_WORKDAY_API_URL + "getManagerDetails",
        headers: {
          apiKey: process.env.REACT_APP_WORKDAY_API_KEY,
          clientKey: process.env.REACT_APP_WORKDAY_API_CLIENTKEY,
          "Content-Type": "application/json",
        },
        data: {
          managerWWID: this.state.mngwwid,
        },
      });
      if (res.status === 200) {
        this.setState({
          mngName: res.data.managerName,
          isValidated: true,
        });
        if (res.data.managerName !== "") {
          if (
            this.state.splocationselected.name == this.state.mnglocation ||
            this.state.mnglocation == ""
          ) {
            this.props.onclickManagerLocationNext(
              this.state.mngwwid,
              this.state.locationreferenceID,
              this.state.mngName,
              this.state.locationname,
              this.state.regionname,
              this.state.countryname,
              this.state.mnglocation
            );
          } else {
            this.setState({ isDifferentlocation: true });
          }
        }
      } else {
        this.setState({
          mngName: "",
          isValidated: true,
        });
      }
    } catch (error) {
      this.setState({
        mngName: "",
        isValidated: true,
      });
    }
  };
  handleUserData = () => {
    this.setState({
      isSubmitted: true,
      isValidated: false,
    });
    if (this.state.mngwwid !== "" && this.state.locationreferenceID !== "") {
      this.validate();
    }
  };
  nolocation = () => {
    this.setState({ isDifferentlocation: false, isSubmitted: false });
  };
  yeslocation = () => {
    this.setState({ isDifferentlocation: false });
    this.props.onclickManagerLocationNext(
      this.state.mngwwid,
      this.state.locationreferenceID,
      this.state.mngName,
      this.state.locationname,
      this.state.regionname,
      this.state.countryname,
      this.state.mnglocation
    );
  };
  render() {
    let regionarr = this.state.dropdownData
      .map((item) => {
        return item.region;
      })
      .filter((val, id, array) => array.indexOf(val) == id)
      .filter(function (el) {
        return el != null && el != "";
      });
    regionarr.push("All");
    let regionlist = regionarr.map((item) => {
      return {
        name: item,
        value: item,
      };
    });
    regionlist = regionlist
      .filter((e) => e.value === "All")
      .concat(
        regionlist
          .filter((e) => e.value !== "All")
          .sort((a, b) => a.value.localeCompare(b.value))
      );

    let countryarr =
      this.state.regionname == "" || this.state.regionname == "All"
        ? this.state.dropdownData
            .map((item) => {
              return item.country;
            })
            .filter((val, id, array) => array.indexOf(val) == id)
            .filter(function (el) {
              return el != null && el != "";
            })
        : this.state.dropdownData
            .filter((it) => {
              return it.region == this.state.regionname;
            })
            .map((item) => {
              return item.country;
            })
            .filter((val, id, array) => array.indexOf(val) == id)
            .filter(function (el) {
              return el != null && el != "";
            });
    countryarr.push("All");
    let countrylist = countryarr.map((item) => {
      return {
        name: item,
        value: item,
      };
    });
    countrylist = countrylist
      .filter((e) => e.value === "All")
      .concat(
        countrylist
          .filter((e) => e.value !== "All")
          .sort((a, b) => a.value.localeCompare(b.value))
      );
    const locationarr =
      this.state.regionname == "" && this.state.countryname == ""
        ? this.state.dropdownData
            .map((item) => {
              return item.location;
            })
            .filter((val, id, array) => array.indexOf(val) == id)
            .filter(function (el) {
              return el != null && el != "";
            })
        : this.state.regionname == "" && this.state.countryname == "All"
          ? this.state.dropdownData
              .map((item) => {
                return item.location;
              })
              .filter((val, id, array) => array.indexOf(val) == id)
              .filter(function (el) {
                return el != null && el != "";
              })
          : this.state.regionname == "" &&
              this.state.countryname != "All" &&
              this.state.countryname != ""
            ? this.state.dropdownData
                .filter((it) => {
                  return it.country == this.state.countryname;
                })
                .map((item) => {
                  return item.location;
                })
                .filter((val, id, array) => array.indexOf(val) == id)
                .filter(function (el) {
                  return el != null && el != "";
                })
            : this.state.regionname == "All" && this.state.countryname == ""
              ? this.state.dropdownData
                  .map((item) => {
                    return item.location;
                  })
                  .filter((val, id, array) => array.indexOf(val) == id)
                  .filter(function (el) {
                    return el != null && el != "";
                  })
              : this.state.regionname == "All" &&
                  this.state.countryname == "All"
                ? this.state.dropdownData
                    .map((item) => {
                      return item.location;
                    })
                    .filter((val, id, array) => array.indexOf(val) == id)
                    .filter(function (el) {
                      return el != null && el != "";
                    })
                : this.state.regionname == "All" &&
                    this.state.countryname != "All"
                  ? this.state.dropdownData
                      .filter((it) => {
                        return it.country == this.state.countryname;
                      })
                      .map((item) => {
                        return item.location;
                      })
                      .filter((val, id, array) => array.indexOf(val) == id)
                      .filter(function (el) {
                        return el != null && el != "";
                      })
                  : this.state.regionname != "" &&
                      this.state.regionname != "All" &&
                      this.state.countryname == ""
                    ? this.state.dropdownData
                        .filter((it) => {
                          return it.region == this.state.regionname;
                        })
                        .map((item) => {
                          return item.location;
                        })
                        .filter((val, id, array) => array.indexOf(val) == id)
                        .filter(function (el) {
                          return el != null && el != "";
                        })
                    : this.state.regionname != "" &&
                        this.state.regionname != "All" &&
                        this.state.countryname == "All"
                      ? this.state.dropdownData
                          .filter((it) => {
                            return it.region == this.state.regionname;
                          })
                          .map((item) => {
                            return item.location;
                          })
                          .filter((val, id, array) => array.indexOf(val) == id)
                          .filter(function (el) {
                            return el != null && el != "";
                          })
                      : this.state.regionname != "" &&
                          this.state.regionname != "All" &&
                          this.state.countryname != "All" &&
                          this.state.countryname != ""
                        ? this.state.dropdownData
                            .filter((it) => {
                              return it.country == this.state.countryname;
                            })
                            .map((item) => {
                              return item.location;
                            })
                            .filter(
                              (val, id, array) => array.indexOf(val) == id
                            )
                            .filter(function (el) {
                              return el != null && el != "";
                            })
                        : this.state.dropdownData
                            .filter((it) => {
                              return it.state == this.state.statename;
                            })
                            .map((item) => {
                              return item.location;
                            })
                            .filter(
                              (val, id, array) => array.indexOf(val) == id
                            )
                            .filter(function (el) {
                              return el != null && el != "";
                            });

    const locationlist = locationarr.sort().map((item) => {
      return {
        name: item,
        value: item,
      };
    });
    return (
      <div>
        {this.state.isLoaded ? (
          <div>
            <div className="headerrow">
              <div className="headercolumn inputtitleheader">
                <div className="last-column rowhead">
                  <div className="titleheader">
                    <p>
                      The Organization code predictor can help you select the
                      correct Legal Entity (LE), MRC, and Cost Center codes for
                      creating a new job requisition.
                    </p>
                    <p>Start by entering the job requisition info below:</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="inputheadercolumn">
              <div className="headerrow">
                <div className="headercolumn">
                  <div className="last-column rowhead">
                    <h4 className="inputlebelheader">
                      Hiring Manager's WWID <span className="astrik">*</span>
                    </h4>
                    <input
                      type="text"
                      className="mngwwid"
                      id="mngId"
                      defaultValue={this.props.mngwwid}
                      name="txt"
                      value={this.state.name}
                      placeholder="Enter Manager WWID"
                      autoComplete="off"
                      onChange={this.handleChange}
                      onBlur={this.showMnglocation}
                    />
                  </div>
                </div>
              </div>
              <div className="headerrow">
                <div className="headercolumn">
                  <div className="last-column rowhead">
                    <h4 className="headertextmiddle">Requisition location</h4>
                  </div>
                </div>
              </div>
              <div className="headerrow">
                <div className="headercolumn">
                  <div className="last-column rowhead">
                    <Dropdown
                      location="Region"
                      astrik=""
                      region={regionlist}
                      placeholderName="Region"
                      regiondata={this.regiondata}
                      previouslocation=""
                      locationselected={this.state.locationselected}
                      currency={this.state.currency}
                    />
                  </div>
                </div>
              </div>
              <div className="headerrow">
                <div className="headercolumn">
                  <div className="last-column rowhead">
                    <Dropdown
                      location="Country"
                      astrik=""
                      region={countrylist}
                      placeholderName="Country"
                      regiondata={this.countrydata}
                      previouslocation=""
                      locationselected={this.state.countryselected}
                      currency={this.state.currency}
                    />
                  </div>
                </div>
              </div>
              <div className="headerrow">
                <div className="headercolumn">
                  <div className="last-column rowhead locationrow">
                    <Dropdown
                      location="J&J site location associated with position"
                      astrik="*"
                      region={locationlist}
                      placeholderName="Search Location"
                      regiondata={this.splocationdata}
                      previouslocation=""
                      locationselected={this.state.splocationselected}
                      currency={this.state.currency}
                    />
                  </div>
                </div>
              </div>
              {this.state.isDisplaymngactualLocation === true ? (
                <div className="headerrow">
                  <div className="headercolumn">
                    <div className="last-column rowhead">
                      <h4 className="locationheadertext">
                        Hiring Manager's Location
                      </h4>
                      <label className="lbltext">
                        {this.state.mnglocation}
                      </label>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="headerrow">
                <div className="headercolumn">
                  <div className="last-column rowhead">
                    {(this.state.mngwwid === "" ||
                      this.state.locationreferenceID === "") &&
                    this.state.isSubmitted ? (
                      <div>
                        <label className="MandatoryFields">
                          Please Enter Mandatory Details(Hiring Manager's WWID
                          and Location)
                        </label>
                      </div>
                    ) : this.state.isSubmitted && !this.state.isValidated ? (
                      <div>
                        <label className="Validationmsg">
                          Validating data...
                        </label>
                      </div>
                    ) : this.state.mngName === "" && this.state.isValidated ? (
                      <div>
                        <label className="MandatoryFields">
                          Please Enter Valid Hiring Manager's WWID
                        </label>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="nextbtn">
                      {" "}
                      <input
                        type="submit"
                        value="Next >"
                        onClick={this.handleUserData}
                        className="btncls"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="dataLoader">Loading data please wait...</div>
        )}
        {this.state.isMandatory === true ? (
          <label className="MandatoryFields">
            Please select a recommended Legal Entity (LE)
          </label>
        ) : (
          ""
        )}
        <Modal
          isOpen={this.state.isDifferentlocation}
          className="Modal locationmodal"
        >
          <div className="outer">
            <div className="middle">
              <div className="middleheadermodal">
                <h1 className="header-margin-class"></h1>
                <p className="para-margin-class ">
                  The Selected Requisition Location and Hiring Manager’s
                  Location do not match. Do you wish to continue ?
                </p>
              </div>
              <div className="decisioncard">
                <input
                  type="submit"
                  value="No"
                  className="btnno"
                  onClick={this.nolocation}
                />
                <input
                  type="submit"
                  value="Yes"
                  className="btnyes"
                  onClick={this.yeslocation}
                />
                <div>
                  <button className="primaryBtn continueBtn respobtn self"></button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default ManagerLocationPage;
